export const type = 'form.advancedRadio';
